/*jshint esversion: 6 */
/* jshint node: true */

/**
 * JS
 */
import "./js/script";

/**
 * SCSS
 */
import "./scss/style.scss";